import { TreeNode } from "utils/tree";
import { SpaceWithParentAccessLevel } from "views/Account/Spaces/types";

export const getIndentSteps = (node: TreeNode<SpaceWithParentAccessLevel>): number =>
  node.path.length - 1 + (node.children.length > 0 ? 0 : 1);

export const getRequiredIndentSteps = (node: TreeNode<SpaceWithParentAccessLevel>): number =>
  node.path.length;
